import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte, BokkzAlgDataService, IncomeTaxEntity,
  OmschrijvingEnBedrag,
  PGASpecifiekeZorgkosten
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SPINNER_TIMEOUT} from "../../../gedeelde-componenten/gedeelde-componenten.component";
import { filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-medicijnen',
  templateUrl: './medicijnen.component.html',
  styleUrls: ['./medicijnen.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule,
  ]
})

export class MedicijnenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    private focusedElementId: string | null = null;

    public medicijnen = {} as FormGroup

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router,private fb: FormBuilder) {
        this.medicijnen = this.fb.group({
            pgaMedicijnen:
                this.fb.array<PGASpecifiekeZorgkosten>([])
        })
    }

    get pgaMedicijnen(): FormArray {
        return this.medicijnen.get('pgaMedicijnen') as FormArray;
    }

    addRijMedicijnen(): void {
        this.pgaMedicijnen.push(this.createMedicijnenFormGroup()
        )
    }

    verwijderRijMedicijnen(index: number): void {
        this.pgaMedicijnen.removeAt(index);
        this.medicijnen.updateValueAndValidity()
        this.medicijnen.markAsDirty()
        this.saveForm()
    }



    createMedicijnenFormGroup(medicijnen?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: medicijnen ? medicijnen.omschrijving : undefined,
            bedrag: medicijnen ? medicijnen.bedrag : undefined
        } as OmschrijvingEnBedrag));
    }

    public ngOnInit(): void {
     this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.updateForm()
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.medicijnen.dirty;
  }

  private updateForm(): void {
        const medicijnenLijst = this.aangifte?.persoonsgebondenAftrek?.pgaSpecifiekeZorgkosten?.medicijnen || [];
        const formArray = this.medicijnen.get('pgaMedicijnen') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > medicijnenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Add or update controls
        for (let i = 0; i < medicijnenLijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(medicijnenLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createMedicijnenFormGroup(medicijnenLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                persoonsgebondenAftrek: {
                    ...this.aangifte.persoonsgebondenAftrek,
                    pgaSpecifiekeZorgkosten: {
                        ...this.aangifte.persoonsgebondenAftrek?.pgaSpecifiekeZorgkosten,
                        medicijnen: this.medicijnen.value.pgaMedicijnen
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
    }
}
